import o from "./index147.js";
/* empty css         */
import t from "./index130.js";
const f = /* @__PURE__ */ t(o, [["__scopeId", "data-v-257221f7"]]);
export {
  f as default
};
